<script lang="ts">
	import { orderStatusNameMap } from "../../../../core/schema/OrderStatus.js";
	import { nbspify } from "../../../../core/utils/nbspify.js";
	import { formatPrice } from "../../../../core/utils/formatPrice.js";
	import type { ProductForCustomer } from "../../../../core/schema/Product.js";
	import type { Image } from "../../../../core/schema/Image.js";
	import type { Order } from "../../../../core/schema/Order.js";
	import { DotSize } from "../../Dot.js";
	import { toWeekdayDateMonthYearFormat } from "../../../../core/utils/toWeekdayDateMonthYearFormat.js";
	import { pickUpBranchMap } from "../../../../core/schema/PickUpBranch.js";
	import { paymentStatusNameMap } from "../../../../core/schema/PaymentStatus.js";
	import OrderDetail from "./OrderDetail.svelte";
	import Icon from "../Icon.svelte";
	import Link from "../Link.svelte";
	import Dot from "../Dot.svelte";
	import printer from "../../../../core/assets/icons/printer.svg?raw";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import { getPriceOfOrderToPay } from "../../../../core/schema/utils/getPriceOfOrderToPay.js";
	import OrderCardContents from "./OrderCardContents.svelte";
	import { paymentStatusDotTypeMap } from "./paymentStatusDotTypeMap.js";
	import { paymentStatusTextColorMap } from "./paymentStatusTextColorMap.js";
	import { orderStatusDotTypeMap } from "./orderStatusDotTypeMap.js";
	import { orderStatusTextColorMap } from "./orderStatusTextColorMap.js";

	export let products: ProductForCustomer[];
	export let order: Order;
	export let imageByProductId: Record<ProductForCustomer["id"], Image>;
	export let onRepeatOrder: () => Promise<void>;

	const globalSettings = getGlobalSettings();
	const { TENANT_LOCALE } = globalSettings;

	const { voucherValue, priceOfOrderToPay } = getPriceOfOrderToPay(order);
</script>

<div class="border-1 group rounded-2xl border-gray-200">
	<div class="grid w-full grid-cols-2 items-start gap-3 p-6 xl:flex xl:flex-row xl:gap-10">
		<OrderDetail label="Stav">
			<p class="font-semibold">
				<Dot size={DotSize.Sm} type={orderStatusDotTypeMap[order.status]} />
				<span class={orderStatusTextColorMap[order.status]}>{orderStatusNameMap[order.status][TENANT_LOCALE]}</span>
			</p>
		</OrderDetail>
		<OrderDetail label="Číslo objednávky"><p class="font-semibold">#{order.orderNumber}</p></OrderDetail>
		<OrderDetail label="Termín dodání">
			<p class="font-semibold">{nbspify(toWeekdayDateMonthYearFormat(order.deliveryDate, TENANT_LOCALE))}</p>
		</OrderDetail>
		<OrderDetail label="Místo dodání">
			<p class="font-semibold">
				{#if order.pickUpBranch !== undefined}
					{nbspify(pickUpBranchMap[order.pickUpBranch])}
				{/if}
			</p>
		</OrderDetail>
		<OrderDetail label="Platba">
			<p class="font-semibold">
				<Dot size={DotSize.Sm} type={paymentStatusDotTypeMap[order.payment.status]} />
				<span class={paymentStatusTextColorMap[order.payment.status]}>
					{nbspify(paymentStatusNameMap[order.payment.status][TENANT_LOCALE])}
				</span>
			</p>
		</OrderDetail>
		<span class="text-md self-end text-end font-semibold lg:hidden"
			>{nbspify(formatPrice(priceOfOrderToPay, TENANT_LOCALE, false))}</span
		>
		<div class="col-span-2 mt-3 flex items-center justify-center lg:hidden">
			{#if order.invoiceUrl}
				<Link
					target="_blank"
					href={order.invoiceUrl}
					asButton
					variant="transparent"
					class="border-1 cursor-pointer rounded-full border-gray-800 px-3 py-1 hover:bg-gray-100"
					><Icon icon={printer} class="h-5 w-5" /> Zobrazit fakturu</Link
				>
			{:else if order.proformaUrl}
				<Link
					target="_blank"
					href={order.proformaUrl}
					asButton
					variant="transparent"
					class="border-1 cursor-pointer rounded-full border-gray-800 px-3 py-1 hover:bg-gray-100"
					><Icon icon={printer} class="h-5 w-5" /> Zobrazit proformu</Link
				>
			{/if}
		</div>
		<div class="ml-auto hidden items-center gap-6 self-end lg:flex">
			<p>
				{#if order.invoiceUrl}
					<Link
						target="_blank"
						href={order.invoiceUrl}
						asButton
						variant="transparent"
						class="border-1 cursor-pointer rounded-full border-gray-800 px-3 py-1 hover:bg-gray-100"
						><Icon icon={printer} class="h-5 w-5" /> Zobrazit fakturu</Link
					>
				{:else if order.proformaUrl}
					<Link
						target="_blank"
						href={order.proformaUrl}
						asButton
						variant="transparent"
						class="border-1 cursor-pointer rounded-full border-gray-800 px-3 py-1 hover:bg-gray-100"
						><Icon icon={printer} class="h-5 w-5" /> Zobrazit proformu</Link
					>
				{/if}
			</p>
			<span class="text-lg font-semibold">{nbspify(formatPrice(priceOfOrderToPay, TENANT_LOCALE, false))}</span>
		</div>
	</div>
	<OrderCardContents {order} {products} {imageByProductId} {onRepeatOrder} {voucherValue} />
</div>
